// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3dhUm","title":"Header_title__2cH3M","side":"Header_side__3iHBh"};